import { ComboboxController } from '@avanta/shared/components/Combobox';
import { DatePickerController } from '@avanta/shared/components/ui/DatePicker';
import { Input } from '@avanta/shared/components/ui/Input';
import { PhoneInputController } from '@avanta/shared/components/ui/PhoneInput';
import { SelectController } from '@avanta/shared/components/ui/Select';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { validationsNickname, validationsRequired } from '@avanta/shared/constants/validations';
import { genderOptions } from '@avanta/shared/types/patients';
import { timezoneOptions, validateAdultBirthDate } from '@avanta/shared/utils/date';
import { validateNIF } from '@avanta/shared/utils/nif';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { type InputForm } from 'types/form';

export const profileForm: Record<string, InputForm> = {
  nickname: {
    label: 'ProfileSettings.Form.nickname.label',
    name: 'nickname',
    type: 'text',
    placeholder: 'ProfileSettings.Form.nickname.placeholder',
    ...validationsRequired,
    ...validationsNickname,
    component: Input,
  },
  nif: {
    label: 'ProfileSettings.Form.nif.label',
    name: 'nif',
    type: 'text',
    placeholder: 'ProfileSettings.Form.nif.placeholder',
    validate: value => !value || validateNIF(String(value)) || 'ProfileSettings.Form.nif.error',
    component: Input,
  },
  firstName: {
    label: 'ProfileSettings.Form.firstName.label',
    name: 'firstName',
    type: 'text',
    placeholder: 'ProfileSettings.Form.firstName.placeholder',
    validate: value =>
      !value || String(value).length >= 3 || 'ProfileSettings.Form.firstName.error',
    component: Input,
  },
  surname: {
    label: 'ProfileSettings.Form.surname.label',
    name: 'surname',
    type: 'text',
    placeholder: 'ProfileSettings.Form.surname.placeholder',
    validate: value => !value || String(value).length >= 3 || 'ProfileSettings.Form.surname.error',
    component: Input,
  },
  contactPhone: {
    label: 'ProfileSettings.Form.contactPhone.label',
    name: 'contactPhone',
    type: 'phone',
    placeholder: 'ProfileSettings.Form.contactPhone.placeholder',
    component: PhoneInputController,
    validate: (value: string | number) => {
      const phone = String(value || '');
      if (!phone) return true;
      return isValidPhoneNumber(phone) || `${LOCIZE_NS.COMMON}:Common.phone.error`;
    },
  },
  gender: {
    label: 'ProfileSettings.Form.gender.label',
    name: 'gender',
    placeholder: 'ProfileSettings.Form.gender.label',
    options: genderOptions,
    component: SelectController,
  },
  dateOfBirth: {
    label: 'ProfileSettings.Form.dateOfBirth.label',
    name: 'dateOfBirth',
    placeholder: 'ProfileSettings.Form.dateOfBirth.placeholder',
    validate: validateAdultBirthDate,
    component: DatePickerController,
  },
  timeZone: {
    label: 'ProfileSettings.Form.timezone.label',
    name: 'timeZone',
    placeholder: 'ProfileSettings.Form.timezone.placeholder',
    options: timezoneOptions,
    component: ComboboxController,
  },
};
